import { render } from "./AppearanceSettings.vue?vue&type=template&id=29a98e11&scoped=true"
import script from "./AppearanceSettings.vue?vue&type=script&lang=js"
export * from "./AppearanceSettings.vue?vue&type=script&lang=js"

import "./AppearanceSettings.vue?vue&type=style&index=0&id=29a98e11&scoped=true&lang=css"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a98e11"]])

export default __exports__